export default __webpack_public_path__ + "static/media/ARIALI.a586e983.woff";